export const LIBRARY_ROBOTS = [
  {
    id: "boston_dynamics_spot",
    name: "Boston Dynamics Spot",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "spot.xml",
    variants: [
      {
        id: "no_arm",
        label: "no arm",
        xmlFilename: "spot.xml",
      },
      {
        id: "with_arm",
        label: "+ arm",
        xmlFilename: "spot_arm.xml",
        thumbnailFilename: "thumbnail-arm.png",
      },
    ],
    defaultVariantId: "no_arm",
  },
  {
    id: "franka_emika_panda",
    name: "Franka Emika Panda",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "panda.xml",
  },
  {
    id: "trossen_wx250s",
    name: "Trossen WX250S",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "wx250s.xml",
  },
  {
    id: "ur5e",
    name: "UR5e",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "model.xml",
    variants: [
      {
        id: "no_gripper",
        label: "no gripper",
      },
      {
        id: "with_robotiq",
        label: "+ 2F-85",
        thumbnailFilename: "thumbnail-gripper.png",
        spawnKeyframe: "home",
        followOnLibraryAssets: [{ folder: "attachments", id: "robotiq_2f85" }],
      },
    ],
    defaultVariantId: "no_gripper",
  },
  {
    id: "ur5e_critter",
    name: "UR5e Critter",
    category: "robot",
    folder: "robots",
    xmlFilename: "ur5e-critter.xml",
    variants: [
      {
        id: "no_gripper",
        label: "no gripper",
      },
      {
        id: "with_robotiq",
        label: "+ 2F-85",
        spawnKeyframe: "home",
        followOnLibraryAssets: [{ folder: "attachments", id: "robotiq_2f85" }],
      },
    ],
    defaultVariantId: "no_gripper",
  },
  {
    id: "unitree_go2",
    name: "Unitree Go2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "go2.xml",
  },
  {
    id: "unitree_g1",
    name: "Unitree G1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "g1.xml",
    spawnKeyframe: "stand",
  },
  {
    id: "agility_cassie",
    name: "Agility Cassie",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "cassie.xml",
    spawnKeyframe: "home",
  },
  {
    id: "agilex_piper",
    name: "Agilex Piper",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "piper.xml",
    spawnKeyframe: "home",
  },
  {
    id: "aloha",
    name: "Aloha",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "aloha.xml",
    thumbnailFilename: "aloha.png",
  },
  {
    id: "anybotics_anymal_b",
    name: "ANYbotics ANYmal B",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "anymal_b.xml",
    thumbnailFilename: "anymal_b.png",
  },
  {
    id: "anybotics_anymal_c",
    name: "ANYbotics ANYmal C",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "anymal_c.xml",
    thumbnailFilename: "anymal_c.png",
  },
  {
    id: "arx_l5",
    name: "ARX L5",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "arx_l5.xml",
    thumbnailFilename: "arx_l5.png",
  },
  {
    id: "apptronik_apollo",
    name: "Apptronik Apollo",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "apptronik_apollo.xml",
    thumbnailFilename: "apptronik_apollo.png",
  },
  {
    id: "a2",
    name: "Unitree A2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "a2.xml",
  },
  {
    id: "b2",
    name: "Unitree B2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "b2.xml",
    thumbnailFilename: "B2.png",
  },
  {
    id: "b2w",
    name: "Unitree B2-W",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "b2w.xml",
    thumbnailFilename: "B2w.png",
  },
  {
    id: "go2w",
    name: "Unitree Go2-W",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "go2w.xml",
  },
  {
    id: "h1",
    name: "Unitree H1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "h1.xml",
    thumbnailFilename: "H1.png",
  },
  {
    id: "h1_2",
    name: "Unitree H1-2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "h1_2_handless.xml",
    thumbnailFilename: "h1_2.png",
  },
  {
    id: "berkeley_humanoid",
    name: "Berkeley Humanoid",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "berkeley_humanoid.xml",
    thumbnailFilename: "berkeley_humanoid.png",
  },
  {
    id: "bitcraze_crazyflie_2",
    name: "Bitcraze Crazyflie 2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "cf2.xml",
    thumbnailFilename: "cf2.png",
  },
  {
    id: "booster_t1",
    name: "Booster T1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "t1.xml",
    thumbnailFilename: "t1.png",
  },
  {
    id: "dynamixel_2r",
    name: "Dynamixel 2R",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "dynamixel_2r.xml",
    thumbnailFilename: "dynamixel_2r.png",
  },
  {
    id: "fourier_n1",
    name: "Fourier N1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "n1.xml",
    thumbnailFilename: "n1.png",
  },
  {
    id: "franka_fr3",
    name: "Franka FR3",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "fr3.xml",
    thumbnailFilename: "fr3.png",
  },
  {
    id: "google_barkour_v0",
    name: "Google Barkour V0",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "barkour_v0.xml",
    thumbnailFilename: "barkour_v0.png",
  },
  {
    id: "google_barkour_vb",
    name: "Google Barkour VB",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "barkour_vb.xml",
    thumbnailFilename: "barkour_vb.png",
  },
  {
    id: "google_robot",
    name: "Google Robot",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "robot.xml",
    thumbnailFilename: "thumbnail.png",
  },
  {
    id: "hello_robot_stretch",
    name: "Hello Robot Stretch",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "stretch.xml",
    thumbnailFilename: "stretch.png",
  },
  {
    id: "hello_robot_stretch_3",
    name: "Hello Robot Stretch 3",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "stretch.xml",
    thumbnailFilename: "stretch.png",
  },
  {
    id: "i2rt_yam",
    name: "I2RT YAM",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "yam.xml",
    thumbnailFilename: "yam.png",
  },
  {
    id: "kinova_gen3",
    name: "Kinova Gen3",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "gen3.xml",
    thumbnailFilename: "gen3.png",
  },
  {
    id: "kuka_iiwa_14",
    name: "KUKA IIWA 14",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "iiwa14.xml",
    thumbnailFilename: "iiwa_14.png",
  },
  {
    id: "low_cost_robot_arm",
    name: "Low Cost Robot Arm",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "low_cost_robot_arm.xml",
    thumbnailFilename: "low_cost_robot_arm.png",
  },
  {
    id: "pal_talos",
    name: "PAL Talos",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene_motor.xml",
    thumbnailFilename: "talos.png",
  },
  {
    id: "pal_tiago",
    name: "PAL Tiago",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene_motor.xml",
    thumbnailFilename: "tiago.png",
  },
  {
    id: "pal_tiago_dual",
    name: "PAL Tiago Dual",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "tiago_dual.xml",
  },
  {
    id: "rethink_robotics_sawyer",
    name: "Rethink Robotics Sawyer",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "sawyer.xml",
  },
  {
    id: "pndbotics_adam_lite",
    name: "Pndbotics Adam Lite",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "adam_lite.xml",
  },
  {
    id: "robot_soccer_kit",
    name: "Robot Soccer Kit",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "robotis_op3",
    name: "Robotis Op3",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "skydio_x2",
    name: "Skydio X2",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "stanford_tidybot",
    name: "Stanford Tidybot",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "trossen_vx300s",
    name: "Trossen Vx300s",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "trs_so_arm100",
    name: "Trs So Arm100",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "ufactory_lite6",
    name: "Ufactory Lite6",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "ufactory_xarm7",
    name: "Ufactory xArm7",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "unitree_a1",
    name: "Unitree A1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "unitree_go1",
    name: "Unitree Go1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "unitree_z1",
    name: "Unitree Z1",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
  },
  {
    id: "universal_robots_ur10e",
    name: "Universal Robots UR10e",
    category: "robot",
    folder: "robots",
    source: "critter-assets",
    xmlFilename: "scene.xml",
    thumbnailFilename: "thumbnail.png",
  },
];

export const LIBRARY_ATTACHMENTS = [
  {
    id: "robotiq_2f85",
    name: "Robotiq 2F-85",
    category: "attachment",
    attachmentKind: "gripper",
    folder: "attachments",
    xmlFilename: "2f85.xml",
  },
  {
    id: "umi_gripper",
    name: "UMI Gripper",
    category: "attachment",
    attachmentKind: "gripper",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "umi_gripper.xml",
  },
  {
    id: "shadow_hand",
    name: "Shadow Hand",
    category: "attachment",
    attachmentKind: "hand",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "right_hand.xml",
    variants: [
      { id: "right", label: "right", xmlFilename: "right_hand.xml" },
      {
        id: "left",
        label: "left",
        xmlFilename: "left_hand.xml",
        thumbnailFilename: "thumbnail-left.png",
        spawnKeyframe: "",
      },
    ],
    defaultVariantId: "right",
    spawnKeyframe: "open hand",
  },
  {
    id: "shadow_dexee",
    name: "Shadow Dexee",
    category: "attachment",
    attachmentKind: "hand",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "shadow_dexee.xml",
    thumbnailFilename: "shadow_dexee.png",
    groupWorldbodyBodiesUnderRoot: "hand_base",
  },
  {
    id: "leap_hand",
    name: "LEAP Hand",
    category: "attachment",
    attachmentKind: "hand",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "right_hand.xml",
    thumbnailFilename: "right_hand.png",
    variants: [
      { id: "right", label: "right", xmlFilename: "right_hand.xml" },
      { id: "left", label: "left", xmlFilename: "left_hand.xml" },
    ],
    defaultVariantId: "right",
  },
  {
    id: "wonik_allegro",
    name: "Wonik Allegro",
    category: "attachment",
    attachmentKind: "hand",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "scene_right.xml",
  },
  {
    id: "iit_softfoot",
    name: "IIT SoftFoot",
    category: "attachment",
    attachmentKind: "foot",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "softfoot.xml",
    thumbnailFilename: "softfoot.png",
  },
  {
    id: "tetheria_aero_hand_open",
    name: "TetherIA Aero Hand Open",
    category: "attachment",
    attachmentKind: "hand",
    folder: "attachments",
    source: "critter-assets",
    xmlFilename: "right_hand.xml",
    thumbnailFilename: "thumbnail-dark.png",
    variants: [
      { id: "right", label: "right", xmlFilename: "right_hand.xml" },
      { id: "left", label: "left", xmlFilename: "left_hand.xml" },
    ],
    defaultVariantId: "right",
  },
];

export const LIBRARY_OBJECTS = [
  { id: "can", name: "Can", category: "object", folder: "objects", source: "critter-assets" },
  {
    id: "book",
    name: "Book",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "Lying down",
    hasGrasps: true,
  },
  {
    id: "bottle",
    name: "Bottle",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    hasGrasps: true,
  },
  {
    id: "bowl",
    name: "Bowl",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "upright",
    hasGrasps: true,
  },
  {
    id: "cellphone",
    name: "Cellphone",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "lying face up",
    hasGrasps: true,
  },
  {
    id: "cup",
    name: "Cup",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "upright",
    hasGrasps: true,
  },
  {
    id: "egg",
    name: "Egg",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "upright",
    thumbnailFilename: "thumbnail.png",
  },
  {
    id: "mug",
    name: "Mug",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    spawnKeyframe: "upright",
    hasGrasps: true,
  },
  {
    id: "plate",
    name: "Plate",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    hasGrasps: true,
  },
  {
    id: "fridge",
    name: "Fridge (Molmo THOR)",
    category: "object",
    folder: "objects",
    source: "critter-assets",
    hasGrasps: true,
  },
  {
    id: "desk_cabinet",
    name: "Desk with cabinet doors (Molmo THOR)",
    category: "object",
    folder: "objects",
    source: "critter-assets",
  },
  { id: "sphere", name: "Ball", category: "basic", folder: "objects" },
  { id: "cube", name: "Cube", category: "basic", folder: "objects" },
  {
    id: "conveyor",
    name: "Conveyor",
    category: "basic",
    folder: "objects",
    source: "critter-assets",
  },
  { id: "tray", name: "Tray", category: "basic", folder: "objects", spawnZ: 0.03 },
];

export const LIBRARY_ITEMS = [...LIBRARY_ROBOTS, ...LIBRARY_ATTACHMENTS, ...LIBRARY_OBJECTS];

export const libraryAssetHasGrasps = (asset) =>
  asset?.folder === "objects" && asset.hasGrasps === true;

export const getLibraryAssetKey = (asset) =>
  `${String(asset?.folder || "")}:${String(asset?.id || "")}:${String(
    asset?.xmlFilename || `${asset?.id || ""}.xml`
  )}`;

export const getLibraryAssetByKey = (assetKey) =>
  LIBRARY_ITEMS.find((asset) => getLibraryAssetKey(asset) === assetKey) || null;

export const XML_SOURCE_CATALOG = [
  ...LIBRARY_ROBOTS.map((asset) => ({
    ...asset,
    group: "Robots",
    xmlPath:
      asset.source === "critter-assets"
        ? `${asset.folder}/${asset.id}/${asset.xmlFilename}`
        : `/${asset.folder}/${asset.id}/${asset.xmlFilename}`,
  })),
  {
    id: "boston_dynamics_spot",
    name: "Boston Dynamics Spot Arm",
    category: "robot",
    folder: "robots",
    group: "Robots",
    source: "critter-assets",
    xmlFilename: "spot_arm.xml",
    xmlPath: "robots/boston_dynamics_spot/spot_arm.xml",
  },
  ...LIBRARY_ATTACHMENTS.map((asset) => ({
    ...asset,
    group: "Attachments",
    xmlPath:
      asset.source === "critter-assets"
        ? `${asset.folder}/${asset.id}/${asset.xmlFilename}`
        : `/${asset.folder}/${asset.id}/${asset.xmlFilename}`,
  })),
  {
    id: "shadow_hand",
    name: "Shadow Hand (left)",
    category: "attachment",
    folder: "attachments",
    group: "Attachments",
    source: "critter-assets",
    xmlFilename: "left_hand.xml",
    xmlPath: "attachments/shadow_hand/left_hand.xml",
  },
  {
    id: "tetheria_aero_hand_open",
    name: "TetherIA Aero Hand Open (left)",
    category: "attachment",
    folder: "attachments",
    group: "Attachments",
    source: "critter-assets",
    xmlFilename: "left_hand.xml",
    xmlPath: "attachments/tetheria_aero_hand_open/left_hand.xml",
  },
  ...LIBRARY_OBJECTS.map((asset) => ({
    ...asset,
    group: "Objects",
    xmlFilename: asset.xmlFilename || `${asset.id}.xml`,
    xmlPath:
      asset.source === "critter-assets"
        ? `${asset.folder}/${asset.id}/${asset.xmlFilename || `${asset.id}.xml`}`
        : `/${asset.folder}/${asset.id}/${asset.xmlFilename || `${asset.id}.xml`}`,
  })),
].map((entry) => ({
  ...entry,
  key: `${entry.group}:${getLibraryAssetKey(entry)}`,
}));

export const XML_SOURCE_GROUPS = [
  {
    id: "robots",
    label: "Robots",
    entries: XML_SOURCE_CATALOG.filter((entry) => entry.group === "Robots"),
  },
  {
    id: "attachments",
    label: "Attachments",
    entries: XML_SOURCE_CATALOG.filter((entry) => entry.group === "Attachments"),
  },
  {
    id: "objects",
    label: "Objects",
    entries: XML_SOURCE_CATALOG.filter((entry) => entry.group === "Objects"),
  },
];
